import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class FileStoreWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    async copyCachedAndPrepareGetRequest(inodeId, offset, bytesToRead, cryptoKey, metadata) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.CopyCachedAndPrepareGetRequest(inodeId, offset.toString(), bytesToRead, cryptoKey, metadata));
        });
    }
    async processGetResult(inodeId, operation, offset, bytesToRead, firstFetchedBlockId, blocks) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ProcessGetResult(inodeId, operation, offset.toString(), bytesToRead, firstFetchedBlockId, blocks));
        });
    }
    async prepareEmptyPutOperation(inodeId, offset, cryptoKey) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.PrepareEmptyPutOperation(inodeId, offset.toString(), cryptoKey));
        });
    }
    async preparePutWithBlocksOperation(inodeId, offset, data, cryptoKey, boundaryBlocks) {
        const operation = await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.PreparePutWithBlocksOperation(inodeId, offset.toString(), data, cryptoKey, boundaryBlocks));
        });
        // This is filled by the log store, we initialize it here otherwise the values is undefined
        operation.request.outcome = {
            blockVersions: new Array(),
        };
        return operation;
    }
    async getPartialBoundaryBlocks(inodeId, offset, size, cryptoKey) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.GetPartialBoundaryBlocks(inodeId, offset.toString(), size, cryptoKey));
        });
    }
    async updateGlobalMetadataAfterPut(inodeId, operation) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.UpdateGlobalMetadataAfterPut(inodeId, operation));
        });
    }
}
